import api from './api';

export const authService = {
  // User login
  login: async (username, password) => {
    const response = await api.post('/api/auth/login', {
      username,
      password,
    });
    return response.data;
  },

  // User registration
  register: async (username, password) => {
    const response = await api.post('/api/auth/register', {
      username,
      password,
    });
    return response.data;
  },

  // Logout
  logout: async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        // Call logout endpoint to blacklist token
        await api.post('/api/auth/logout', {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (error) {
        console.warn('Logout API call failed:', error);
      }
    }
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
  },

  // Refresh token
  refreshToken: async () => {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }
    
    const response = await api.post('/api/auth/refresh', {
      refresh_token: refreshToken,
    });
    
    const newToken = response.data.access_token;
    localStorage.setItem('token', newToken);
    return newToken;
  },

  // Get current user (if token exists)
  getCurrentUser: () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        // Decode JWT payload (simple base64 decode - not secure validation)
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 < Date.now()) {
          localStorage.removeItem('token');
          return null;
        }
        return {
          id: payload.user_id,
          username: payload.username,
          role: payload.role,
        };
      } catch (error) {
        localStorage.removeItem('token');
        return null;
      }
    }
    return null;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  // Check if user is admin
  isAdmin: () => {
    const user = authService.getCurrentUser();
    return user?.role === 'admin';
  },
};
